var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row bg-main-banner main-banner-height p-banner",attrs:{"id":"sec-booking"}},[_c('div',{staticClass:"col-xxl-6 col-xl-8 col-md-10 col-sm-12 mx-auto px-0 homepage-booking-section-max-w"},[_c('SelectDate')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }